import { useAuthStore } from "../stores/authStore";
const defaultProfilePicture = "/app-assets/images/common/no-profile-pic.png";

export const checkImageExists = (url) => {
	return new Promise((resolve) => {
		const img = new Image();
		img.onload = () => resolve(true);
		img.onerror = () => resolve(false);
		img.src = url;
	});
};

export const getUserPicturePath = async (keyPicture, folderName, folder) => {
	const url = window.location.origin;
	const devUrl = import.meta.env?.VITE_IS_SSL
		? `https://${location.hostname}/`
		: `${url}/`;

	if (!keyPicture) return defaultProfilePicture;

	const userFolderImgUrl = getCommonFolderUrl(folderName, folder, devUrl);
	if (!userFolderImgUrl) return defaultProfilePicture;

	const pictureUrl = `${userFolderImgUrl}${keyPicture}`;
	const exists = await checkImageExists(pictureUrl);

	const finalPath = exists ? pictureUrl : defaultProfilePicture;
	const authStore = useAuthStore();
	authStore.setProfilePicture(finalPath);
	return finalPath;
};

export const getProfilePicture = () => {
	const store = useAuthStore();
	return store?.user?.profilePicturePath || defaultProfilePicture;
};

function getCommonFolderUrl(folderName, folder, baseUrl) {
	if (folderName) {
		return `${baseUrl}safejournal/uploads/${folderName}/${folder}/`;
	}
	return null;
}
